/**
 * 플로팅 문의하기 버튼
 * 채널톡 스타일로 화면 하단 우측에 고정 표시됩니다.
 */

import { useState, useCallback } from "react";
import { Headset } from "lucide-react";
import { ContactSheet } from "./ContactSheet";

export function FloatingContactButton() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      {/* 플로팅 버튼 - 스크린샷 캡처에서 제외 */}
      <button
        type="button"
        onClick={handleOpen}
        className="html2canvas-ignore fixed right-4 z-[100] flex h-11 w-11 items-center justify-center rounded-full bg-blue-500 shadow-lg transition-transform active:scale-95"
        style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)" }}
        aria-label="문의하기"
      >
        <Headset className="h-5 w-5 text-white" />
      </button>

      {/* 문의 시트 */}
      {isOpen && <ContactSheet onClose={handleClose} />}
    </>
  );
}
